module.exports = __webpack_public_path__ + "img/BO.04a280e7.svg";